module.exports = __webpack_public_path__ + "img/4e3c441.png";